// Whether a customer may delete their account from the app.
//
// The server allows a deletion only while the wallet is at ₹0 — neither
// owing the store nor holding the customer's money
// (routes_customer._start_wallet_deletion). This mirrors that rule so the app
// can say so before the customer types DELETE, instead of after. The server is
// still the authority — this only decides what the dialog shows.

const inr = (n) => n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** The sentence the dialog shows when deletion is blocked, or null. A
 *  balance that rounds to ₹0.00 counts as zero, as on the server. */
export function deletionBlockedReason(balance) {
  const n = Number(balance);
  if (!Number.isFinite(n) || Math.abs(n) < 0.005) return null;
  if (n < 0) {
    return `Your wallet balance is -₹${inr(Math.abs(n))}. Please clear the balance (add money to your wallet) before deleting your account.`;
  }
  return `Your wallet still has ₹${inr(n)}. An account can only be deleted when the wallet balance is ₹0 — please use the balance, or ask the store to settle it, before deleting your account.`;
}
